import { Component, OnInit, Input } from '@angular/core';
import { ControlContainer, FormGroup } from '@angular/forms';
import { Store } from '@ngrx/store';
import { get } from 'lodash';
import { Observable } from 'rxjs';
import { first } from 'rxjs/operators';

import { optionsMap } from 'src/app/models/options-map';
import { AppState } from '../../app-reducer';


@Component({
  selector: 'name-form',
  templateUrl: './name-form.component.html'
})
export class NameFormComponent implements OnInit {
  @Input() parent: FormGroup;
  @Input() isRequired: boolean;
  Prefix: any;
  Suffix: any;
  isDemo = false;


  public nameFormGroup: FormGroup;
  formGroupParent: any;
  appState$: Observable<any>;
  constructor(private controlContainer: ControlContainer,
     private store: Store<AppState>
    ) { 
    this.appState$ = store.select('sections');
  }

  ngOnInit() {
    this.nameFormGroup = <FormGroup>this.controlContainer.control;
    this.formGroupParent = this.controlContainer.name;

    this.Prefix = get(optionsMap.prefix, 'options');

    this.Suffix = get(optionsMap.suffix, 'options');
    
    this.appState$.pipe(first()).subscribe((state: any) => {
      if (state.isDemo){
        this.isDemo = true;
        this.setDemoName();
      }
    });

  }

  setDemoName(){
    this.nameFormGroup.patchValue({FirstName:'Customer', LastName:'Name'});
    this.nameFormGroup.disable();
  }

}
